export default __webpack_public_path__ + "static/media/HANA_Packshot.5fee0574.png";